import { KFTextInput } from "@kf/ic2fx";
import { List, ListItem, ListItemText } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { range } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import SearchIcon from "../../../assets/icons/search_Icon_SJPR.svg";
import closeIcon from "../../../assets/icons/sjpr_Close Icon.svg";
import { Icountry } from "../../../components/JobPricing/ChooseCountry";
import { PAGE_URL } from "../../../constants/urls.constants";
import {
  JobPricingHeaderDetails,
  JobPricingReportViewBy,
  JobPricingSections
} from "../../../helpers/models/JobPricingDetailModels";
import type { RootState } from "../../../store/reducers";
import {
  resetPricingDetailsState,
  setReturnToDataList,
  updateReportHeaderDetails,
  updateReportViewBy
} from "../../../store/slices/jobPricingDetailsSlice";
import { updateJobPricingPayloads } from "../../../store/slices/jobPricingSearchSlice";
import {
  JobSearchListThunk,
  PrepopulatedSearchesThunk,
  resetJobSearch,
  resetJobSearchList,
  setSearchItemClicked
} from "../../../store/slices/jobPricingSlice";
import {
  resetFilters,
  resetPeerGroupId,
  updatedSearchKey,
  updateJobCatogery
} from "../../../store/slices/SJPR/listSlice";
import styles from "./index.module.scss";
import "./index.scss";

const CustomTextInput = styled(KFTextInput)(({ theme }) => ({
  "& .kfic2-textInput": {
    borderRadius: "20px"
  }
}));

const SearchJobPricing = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useNavigate();
  const [isSearching, setIsSearching] = useState(false);
  const [name, setNamespace] = useState<any>();
  const [open, setOpen] = useState(false);
  const [listofJobs, setListofJobs] = useState<any>([]);
  const [selectedCountryState, setSelectedCountryState] = useState<Icountry>();
  const { jobPricingDetails, jobpricing, country } = useSelector(
    (state: RootState) => state
  );
  //  debouncing search block
  const initSearch = async (_keyword: any) => {
    const key = selectedCountryState?.key;
    if (_keyword.length >= 3 && key) {
      dispatch(JobSearchListThunk({ key, _keyword }));
    }
  };
  const currentRouterURL = location.pathname;

  useEffect(() => {
    const getData = setTimeout(() => {
      if (name.length >= 3) {
        setListofJobs([]);
        initSearch(name);
      }
    }, 1000);

    return () => clearTimeout(getData);
  }, [name]);

  const getList = () => {
    let _jobSearchResultList: any = jobpricing?.jobSearchResultList;
    for (let list in _jobSearchResultList) {
      if (_jobSearchResultList[list]) {
        _jobSearchResultList[list].map((item: any) => {
          setListofJobs((prev: any) => [...prev, item]);
        });
      }
    }
  };

  const updateReportPricingViewBy = (item: any) => {
    if (item[JobPricingSections.JOB_TITLE]) {
      return JobPricingReportViewBy.JOB;
    } else if (item[JobPricingSections.FUNCTION_TITLE]) {
      return JobPricingReportViewBy.FUNCTION;
    } else if (item[JobPricingSections.GRADE]) {
      return JobPricingReportViewBy.GRADE;
    } else {
      return JobPricingReportViewBy.JOB;
    }
  };

  const getGradeIDRange = (gradeSpan: string) => {
    if (!gradeSpan) return "";
    const gradeRange = gradeSpan.split("-");
    if (!gradeRange || gradeRange.length === 0) return "";
    return range(+gradeRange[0], +gradeRange[1] + 1).join();
  };

  const updateReportPricingHeaderDetails = (item: any) => {
    const updatedPricingPayloads = {
      searchCategory: updateReportPricingViewBy(item),
      jobKey: (item?.jobKey || "ALL").toString(),
      jobOrgCode: (item?.jobOrgCode || "ALL").toString(),
      jobName: "",
      jobDescription: item?.jobDescription || "",
      jobFamilyName: item?.jobFamilyName || "ALL",
      jobSubFamilyName: item?.jobSubFamilyName || "ALL",
      marketJobFamily: (item?.jobFamilyKey || "ALL").toString(),
      marketJobSubFamily: (item?.jobSubFamilyKey || "ALL").toString(),
      totalJobs: item?.totalJobs || "0",
      jobsInOrg: item?.jobsInOrg || "0",
      gradeId: (
        getGradeIDRange(item?.gradeSpan) ||
        item?.grade ||
        "ALL"
      ).toString(),
      gradeSpan: item?.gradeSpan || "ALL",
      searchTerm: ""
    };
    const pricingHeaderDetails = {
      title: "",
      description: item?.jobDescription || "",
      function: item?.jobFamilyName || "-",
      grade: item?.grade || "-",
      gradeSpan: item?.gradeSpan || "-",
      jobCode: item?.jobOrgCode || "0",
      subFunction: item?.jobSubFamilyName || "-",
      totalJobs: item?.totalJobs || "0",
      orgJobs: item?.jobsInOrg || "0"
    } as JobPricingHeaderDetails;
    if (item[JobPricingSections.JOB_TITLE]) {
      pricingHeaderDetails.title = item.jobName;
      updatedPricingPayloads.jobName = item.jobName;
      updatedPricingPayloads.searchTerm = item.jobName;
    } else if (item[JobPricingSections.FUNCTION_TITLE]) {
      pricingHeaderDetails.title = item.functionTitle;
      updatedPricingPayloads.jobName = item.functionTitle;
      updatedPricingPayloads.searchTerm = item.functionTitle;
    } else if (item[JobPricingSections.GRADE]) {
      pricingHeaderDetails.title =
        JobPricingReportViewBy.GRADE + " " + item.grade;
      updatedPricingPayloads.jobName =
        JobPricingReportViewBy.GRADE + " " + item.grade;
      updatedPricingPayloads.searchTerm =
        JobPricingReportViewBy.GRADE + " " + item.grade;
    } else {
      pricingHeaderDetails.title = "";
      updatedPricingPayloads.searchTerm = "";
    }
    dispatch(updateJobPricingPayloads(updatedPricingPayloads));
    dispatch(updateReportHeaderDetails(pricingHeaderDetails));
  };

  const handleselectItem = (item: any) => {
    dispatch(resetPricingDetailsState());
    dispatch(resetFilters());
    dispatch(resetPeerGroupId());
    dispatch(setReturnToDataList(false));
    setOpen(false);
    dispatch(resetJobSearchList());
    setListofJobs([]);
    dispatch(updateReportViewBy(updateReportPricingViewBy(item)));
    updateReportPricingHeaderDetails(item);
    if (currentRouterURL && currentRouterURL !== PAGE_URL.JOB_PRICING_DETAILS) {
      history(PAGE_URL.JOB_PRICING_DETAILS);
    }
    setNamespace("");
    dispatch(setSearchItemClicked(true));
  };

  useEffect(() => {
    setNamespace("");
    setListofJobs([]);
    setIsSearching(false);
    setSelectedCountryState(country?.selectedCountry);
    dispatch(resetJobSearch());
    country?.selectedCountry?.key &&
      currentRouterURL &&
      currentRouterURL === PAGE_URL.JOB_PRICING &&
      dispatch(PrepopulatedSearchesThunk(country?.selectedCountry?.key));
  }, [country.selectedCountry]);

  const displayJobs = (item: any, index: any) => {
    if (item[JobPricingSections.JOB_TITLE]) {
      return (
        <ListItem
          key={index}
          disableGutters
          onClick={() => {
            handleselectItem(item);
          }}
        >
          <ListItemText
            primary={item.jobName}
            secondary={`${item.jobFamilyName} | ${t("pa.grade")}: ${
              item.grade
            } | ${t("pa.Incumbents")}: ${item.incumbentCount}`}
          />
        </ListItem>
      );
    } else if (item[JobPricingSections.GRADE]) {
      return (
        <ListItem
          key={index}
          disableGutters
          onClick={() => {
            handleselectItem(item);
          }}
        >
          <ListItemText
            primary={t("pa.grade") + item.grade}
            secondary={`${t("pa.totalJobs")}: ${item.totalJobs} | ${t(
              "pa.jobsInOrg"
            )}: ${item.jobsInOrg} | ${t("pa.Incumbents")}: ${item.incumbents}`}
          />
        </ListItem>
      );
    } else if (item[JobPricingSections.FUNCTION_TITLE]) {
      return (
        <ListItem
          key={index}
          disableGutters
          onClick={() => {
            handleselectItem(item);
          }}
        >
          <ListItemText
            primary={item.functionTitle}
            secondary={`${item.gradeSpan} | ${t("pa.Incumbents")}: ${
              item.totalIncumbents
            } | Jobs: ${item.totalJobs}`}
          />
        </ListItem>
      );
    }
    // else if (item["jobCode"]) {
    //   return (
    //     <ListItem
    //       key={index}
    //       disableGutters
    //       onClick={() => {
    //         setOpen(false);
    //         handleselectItem(item);
    //         setNamespace(item.jobCodeName);
    //       }}
    //     >
    //       <ListItemText
    //         primary={item.jobCodeName}
    //         secondary={`${item.jobSubFamily} | ${item.jobFamily} | Jobs: ${item.totalJobs}`}
    //       />
    //     </ListItem>
    //   );
    // }
  };

  const handleSearch = (value: any) => {
    value ? setIsSearching(true) : setIsSearching(false);
    setNamespace(value);
  };

  const renderHelperText = (value: any) => {
    if (value?.match(/(\d+)/)?.length > 0 && value.length <= 2) {
      return t("pa.sjpr.search.NumericValidation");
    }
    if (value && value?.length < 3) {
      return t("pa.sjpr.search.searchHelperText");
    }
    return "";
  };

  useEffect(() => {
    if (jobpricing?.jobSearchResultList) {
      getList();
      setIsSearching(false);
      name && setOpen(true);
    }
  }, [jobpricing?.jobSearchResultList]);

  return (
    <div className={styles.searchBlock}>
      <CustomTextInput
        error={name && name?.length < 3 ? true : false}
        variant="standard"
        label=""
        autoComplete="off"
        autoFocus
        disabled={
          country?.selectedCountry?.key
            ? false
            : true || jobpricing?.isJobSearchDisabled
        }
        placeholder={t("pa.sjpr.searchPlaceholder")}
        className={
          currentRouterURL && currentRouterURL === PAGE_URL.JOB_PRICING
            ? styles.multiSelectAutoComplete
            : styles.searchInputPricingDetails
        }
        onChange={(event) => {
          handleSearch(event.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && name && name?.length >= 3) {
            if (
              name?.toLocaleLowerCase().includes(t("pa.sjpr.searchKey.grade"))
            ) {
              dispatch(updateJobCatogery("grade"));
            }
            history("/sjpr/job-search-results");
            sessionStorage.setItem("searchKey", JSON.stringify(name));
            dispatch(updatedSearchKey(name));
            dispatch(resetJobSearchList());
            setListofJobs([]);
          }
        }}
        helperText={renderHelperText(name)}
        value={name || ""}
        InputProps={{
          startAdornment: (
            <img
              src={SearchIcon}
              alt="search icon"
              style={{
                padding: "10px 10px 10px 0px",
                cursor: "pointer"
              }}
            />
          ),
          endAdornment:
            (isSearching || jobpricing?.isJobSearchsLoading) &&
            name?.length >= 3 ? (
              <CircularProgress style={{ color: "#757575 " }} size={25} />
            ) : (
              name && (
                <img
                  src={closeIcon}
                  alt=""
                  style={{
                    padding: "10px 0px 10px 0px",
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    setNamespace("");
                    dispatch(resetJobSearchList());
                    setListofJobs([]);
                  }}
                />
              )
            )
        }}
      />
      {open && name && !isSearching && (
        <List sx={{ bgcolor: "background.paper" }} className={styles.modal}>
          {listofJobs?.length > 0 ? (
            listofJobs?.map((item: any, index: any) => {
              return displayJobs(item, index);
            })
          ) : (
            <div className={styles.noResultsFound}>
              {t("pa.sjpr.search.noDataFound")}
            </div>
          )}
        </List>
      )}
    </div>
  );
};

export default SearchJobPricing;
